// libraries
import Vue from 'vue'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

// styles
import '@/sass/_bootstrap.sass'
import '@/sass/_colors.sass'
import '@/sass/_fonts.sass'
import '@/sass/_components.sass'

// components
import App from './App.vue'

// router
import router from '@/routes/index.js'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.config.productionTip = false

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app')
